import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadPdf(url, filename) {
  const res = await api.get(url, { responseType: "blob" });
  const blobUrl = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename || "document.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(blobUrl);
}

export async function downloadInvoicePdf(invoiceId, number) {
  return downloadPdf(`/invoices/${invoiceId}/pdf`, `${number || "invoice"}.pdf`);
}

// Authenticated URL for object-storage files (img src can't send headers, so use query-param auth)
export function fileUrl(path) {
  const token = localStorage.getItem("wl_token");
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}?auth=${token}`;
}

export async function uploadProof(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await api.post("/uploads/proof", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return res.data.path;
}

export default api;
